import List from '@creditflowresearch/uilib/List';
import SectionItem from '@creditflowresearch/uilib/SectionItem';
import { ISectionItem } from '@creditflowresearch/uilib/Section';

interface ISectionItemListProps {
  items: ISectionItem[],
}

const SectionItemList = ({
  items,
}: ISectionItemListProps) => (
  <List
    items={ items }
    renderItem={ (item) => <SectionItem item={ item } /> }
    gap={ 0 }
  />
);

export default SectionItemList;
